import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';
import { barbaController } from '../../common/page-lifecycle/barba/BarbaController';

const DEBUG_VERBOSE: boolean = false;
export const HHDSButtonHeaderTagName: string = 'hhds-button-header';
const TAG_NAME: string = HHDSButtonHeaderTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSButtonHeaderAttrNames = {
	active: 'active',
	href: 'href',
};

const Attrs = HHDSButtonHeaderAttrNames;

export class HHDSButtonHeader extends Component {
	private clickFunc: () => void;
	private pointerEnterFunc: () => void;
	private pointerLeaveFunc: () => void;

	constructor() {
		super();
		this.clickFunc = this.onClick.bind(this);
		this.pointerEnterFunc = this.onPointerEnter.bind(this);
		this.pointerLeaveFunc = this.onPointerLeave.bind(this);
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = /* html */ `<button class="${TAG_NAME}" role="link"><slot></slot></button>`;
		this.setInnerHtml('', '', html);

		const button = this.element('button');
		button?.addEventListener('click', this.clickFunc);
		button?.addEventListener('pointerenter', this.pointerEnterFunc);
		button?.addEventListener('pointerleave', this.pointerLeaveFunc);
	}

	private onClick(): void {
		const href: string = this.vars.get<string>(Attrs.href);
		if (href?.length) barbaController.navigateTo(href);
	}

	private onPointerEnter(): void {
		const heading = this.element('.heading');
		heading?.classList.toggle('heading--enter', true);
		heading?.classList.toggle('heading--leave', false);
	}

	private onPointerLeave(): void {
		const heading = this.element('.heading');
		heading?.classList.toggle('heading--leave', true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');

		const button = this.element('button');
		button?.removeEventListener('click', this.clickFunc);
		button?.removeEventListener('pointerenter', this.pointerEnterFunc);
		button?.removeEventListener('pointerleave', this.pointerLeaveFunc);
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);

		const active = this.vars.get<boolean>(Attrs.active);

		const burgerLines = this.root.querySelectorAll('.burger__line') as NodeListOf<HTMLElement>;
		burgerLines.forEach((line) => line.classList.toggle(`burger__line--active`, active));
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	[Attrs.active]: {
		description: 'Active',
		type: Boolean,
		defaultValue: false,
	},
	[Attrs.href]: {
		description: 'Button href',
		type: String,
		defaultValue: '',
	},
};
